var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordionviewer"},[_c('div',{staticClass:"panes-container"},[_c('div',{staticClass:"center-pane",attrs:{"id":"center-pane"}},[_c('ul',{style:(_vm.ulStyle)},_vm._l((_vm.data),function(itemdata,index){return _c('div',[_c('item',{staticClass:"item",attrs:{"top":_vm.getTop(index),"model":itemdata,"textItems":_vm.text,"targetEl":false,"open":false}})],1)}))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c4777b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccordionViewer.vue
// module id = 1234
// module chunks = 1